import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudCpeViewModel } from '../datosbasicos/cpe.types';


@Injectable()
export class EnvioCpeService {

   
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {


    }    
    
   
    validarSolicitud(id: number): Observable<string[]> {
        return this.http
            .get<string[]>(this.baseUrl + 'api/exportacion/cpes/envioCpe/' + id).pipe();
    }

    envioSolicitud(solicitudCpe: SolicitudCpeViewModel): Observable<SolicitudCpeViewModel> {
        return this.http
            .put<SolicitudCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/envioCpe', solicitudCpe).pipe();
    }
   
    getCertificadoPrevioEx(idCpe: number): Observable<HttpResponse<Blob>> {

        return this.http.post(this.baseUrl + 'api/exportacion/cpes/envioCpe/GetPdfCertificadoPrevioEx', idCpe, { observe: 'response', responseType: 'blob' })
            .pipe();
    }
    
}
